import {Component, EventEmitter, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterLink} from '@angular/router';
import {SimplebarAngularModule} from 'simplebar-angular';
import {NgClickOutsideDirective} from 'ng-click-outside2';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';
import {UserInfo} from '../../../core/models/user/user-info.model';

@Component({
  selector: 'app-layout-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    SimplebarAngularModule,
    NgClickOutsideDirective
  ],
  templateUrl: './layout-navbar.component.html',
  styleUrl: './layout-navbar.component.scss'
})
export class LayoutNavbarComponent {
  show: boolean = true;
  notification:boolean = false;

  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService
  ) {
  }

  get userInfo(): UserInfo | undefined {
    return this.authenticationService.userData;
  }

  onClickedOutside(e: Event) {
    this.notification = false
  }

  user:boolean = false

  onClickedOutside2(e: Event) {
    this.user = false
  }

  @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggleShow(e:any) {
    e.preventDefault();
    this.show = !this.show;
    this.showChange.emit(this.show);  // Emit the `show` value
  }

  logout(): void {
    this.authenticationService.logout();
    this.show = false;
    this.router.navigate(['/login']);
  }
}
